import { useSearchParams } from 'react-router-dom';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/componentes/ui/tabs';
import { Pagina } from '@/layout/pagina';

import { Acessos } from './acessos';
import { Empresas } from './empresas';
import { SoAdmin } from './guarda';
import { Papeis } from './papeis';
import { VisaoGeral } from './visao-geral';

/* Painel de administração. Este arquivo só decide O QUE mostrar.
 *
 * Não é etapa do funil e por isso não entra em `etapas.ts`: aquela lista é o
 * caminho do integrador até o preço, e administrar não faz parte dele.
 *
 * A ABA VIVE NO ENDEREÇO, junto da busca e da página da lista. Quem abre uma
 * empresa e volta cai de novo na aba Empresas, com o mesmo termo buscado e na
 * mesma página — com o estado só na memória do componente, o voltar
 * devolveria a visão geral e o trabalho de encontrar aquele nome de novo. */
export function Admin() {
  const [parametros, definirParametros] = useSearchParams();
  const aba = parametros.get('aba') ?? 'visao-geral';

  const trocarAba = (nova: string) => {
    // A busca e a página são da aba Empresas: levá-las junto para outra aba
    // deixaria lixo no endereço e faria a lista voltar filtrada sem motivo.
    definirParametros(nova === 'visao-geral' ? {} : { aba: nova }, { replace: true });
  };

  return (
    <SoAdmin>
      <Pagina titulo="Administração" descricao="Cadastros, atividade e acesso ao painel.">
        <Tabs value={aba} onValueChange={trocarAba} className="grid gap-4">
          <TabsList>
            <TabsTrigger value="visao-geral">Visão geral</TabsTrigger>
            <TabsTrigger value="empresas">Empresas</TabsTrigger>
            <TabsTrigger value="acessos">Visitas</TabsTrigger>
            <TabsTrigger value="papeis">Acesso ao painel</TabsTrigger>
          </TabsList>

          <TabsContent value="visao-geral">
            <VisaoGeral />
          </TabsContent>
          <TabsContent value="empresas">
            <Empresas />
          </TabsContent>
          <TabsContent value="acessos">
            <Acessos />
          </TabsContent>
          <TabsContent value="papeis">
            <Papeis />
          </TabsContent>
        </Tabs>
      </Pagina>
    </SoAdmin>
  );
}
